// src/components/EvaluationModal.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { CloseIcon } from "../../assets/icons/icons";
import { supabase } from "../../supabaseClient";
import { useConfig } from "../../contexts/ConfigContext";
import "./style.css";


export default function TrialFourDay({ isOpen, closeModal, userId }) {
  const navigate = useNavigate();
  const API_BASE = useConfig().config.apiBase;
  if (!isOpen) return null;

  const handleAcknowledge = async () => {
    if (!userId) return;
    const { error } = await supabase
      .from("users")
      .update({ trial_acknowledge: true })
      .eq("id", userId);
    if (error) console.error("Failed to record acknowledgment:", error);
    closeModal();
  };

  const handlePurchase = () => {
    // send them to your account billing tab
    navigate("/purchase-subscription");
    closeModal();
  };

  return (
    <div className="evaluation-modal-overlay" onClick={closeModal}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="evaluation-creation-container">
          <div className="modal-header">
            <h2>SWP Trial Ending Soon</h2>
            <CloseIcon onClick={closeModal} className="cancel-icon" />
          </div>
          <div className="modal-body">
            <p>
              Today is <strong>Day 4</strong> of your <strong>7-day</strong> Sports Wellness Platform trial. You still have full access to the SWP until the trial ends.
            </p>
            <p>
              After your trial wraps up, you’ll need an active subscription to continue using SWP’s features.
            </p>
          </div>
          <div className="modal-footer">
            <button className="btn-secondary" onClick={handleAcknowledge}>
              I Acknowledge
            </button>
            <button className="btn-primary" onClick={handlePurchase}>
              Purchase Subscription
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
